
function querySelectorAll(selector) {
    return [].slice.call(
        document.body.querySelectorAll(selector)
    )
}

function isMobile() {
  // Check user agent for mobile devices
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const mobileRegex = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
  
  // Check if user agent matches mobile devices
  const isMobileUA = mobileRegex.test(userAgent.toLowerCase());
  
  // Check screen width (tablets and phones typically under 1024px)
  const isMobileWidth = window.innerWidth < 1024;
  
  return isMobileUA || isMobileWidth;
}


class FacetsUtility {
    constructor() {
        this.form = document.body.querySelector('.facets__form');

        this.data = [];
        this.start();
    }

    async start() {
        const data = await this.fetchFacetsData();

        this.data = data;
        this.syncIndividualTags();
        // this.syncTagInputs()
    }

    syncIndividualTags = () => {
        const $inputs = this.tagInputs;

        // if is mobile we should do 'on click' for the drawer button.
        
        if(!isMobile()) {
            this.multiStepTagFilterContainers.forEach((container) => {
                container.addEventListener('mouseenter', () => {
                    this.syncContainersTags(container);
                }, { once: true })
            });
        } else {
            document.querySelector('.mobile-facets__btn').addEventListener('click', () => {
                   this.multiStepTagFilterContainers.forEach((container) => {
                            this.syncContainersTags(container);
                    });                
            }, { once: true })
        }

        console.log('[FacetsUtilityClass] multiStepTagFilter:', this.multiStepTagFilterContainers);
    }

    syncContainersTags = async (container) => {
        const tagInputs = Array.from(
            container.querySelectorAll('input[name="filter.p.tag"]')
        );

        console.log('Sync container tags');

        // run simultaneously
        await Promise.all(
            tagInputs.map(async (input) => {
                const { value } = input;
                const count = await this.getTaggedEndpointCount(value);
                const shouldHide = count === 0;
                
                if(shouldHide) input.parentElement.style.display = 'none';
                
                console.log('Tag Count', value, count);
            })
        )

    }

    getTaggedEndpointCount = (tag) => {
        return fetch(this.createTagggedEndpoint(tag)).then((response) => response.json()).then((data) => data.count);
    }

    createTagggedEndpoint = (tag) => {
        return `/collections/${this.collectionHandle}?filter.p.tag=${tag}&view=data`;   
    }

    syncTagInputs() {
        const tagData = this.data.find((data) => data.name === 'filter.p.tag');
        const tagsWithCount = tagData.values.filter(({ count }) => count > 0).map(({ value }) => value.toLowerCase());

        this.tagInputs.forEach((input) => {
            const { value } = input;

            if(!tagsWithCount.includes(value.toLowerCase())) {
                // const $container = input.closest('[data-controller="accordion"]');

                // console.log('[FacetsUtilityClass] hideInput:', input, value);
                input.parentElement.style.display = 'none';
                // if($container) $container.style.display = 'none';
            } 
        })
        console.log('[FacetsUtilityClass] tagdata:', tagData, this.tagInputs, tagsWithCount);
    }

    fetchFacetsData() {
        return fetch(`/collections/${this.collectionHandle}?view=facets`).then((res) => res.json());
    }

    get collectionHandle() {
        let [_, template, handle] = window.location.pathname.split('/');

        return handle;
    }

    get multiStepTagFilterContainers() {
        return querySelectorAll('.multi-step-tag-filter');
    }

    get tagInputs() {
        return querySelectorAll('input[name="filter.p.tag"]');
    }
}

new FacetsUtility()